<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">CONTENTS</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/Book3/4start#chap1">PROLOGUE</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book3/6chap2#chap2">ONE: The Shades of Spring</a></p>
<p class="toc2"><a href="#/Book3/7chap3#chap3">1. Before the Sun</a></p>
<p class="toc2"><a href="#/Book3/8chap4#chap4">2. Down in the Dark</a></p>
<p class="toc2"><a href="#/Book3/9chap5#chap5">3. The Invader </a></p>
<p class="toc2"><a href="#/Book3/10chap6#chap6">4. Wasps at Easter</a></p>
<p class="toc2"><a href="#/Book3/11chap7#chap7">5. The Death of a Bike</a></p>
<p class="toc2"><a href="#/Book3/12chap8#chap8">6. Old Moses Comes to Call</a></p>
<p class="toc2"><a href="#/Book3/13chap9#chap9">7. A Summons From the Lady</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book3/14chap10#chap10">TWO: A Summer of Devils and Angels</a></p>
<p class="toc2"><a href="#/Book3/15chap11#chap11">1. Last Day of School</a></p>
<p class="toc2"><a href="#/Book3/16chap12#chap12">2. Barbershop Talk</a></p>
<p class="toc2"><a href="#/Book3/17chap13#chap13">3. A Boy And a Ball</a></p>
<p class="toc2"><a href="#/Book3/18chap14#chap14">4. I Get Around</a></p>
<p class="toc2"><a href="#/Book3/19chap15#chap15">5. Welcome, Lucifer</a></p>
<p class="toc2"><a href="#/Book3/20chap16#chap16">6. Nemo’s Mother &amp; A Week With the Jaybird</a></p>
<p class="toc2"><a href="#/Book3/21chap17#chap17">7. My Camping Trip</a></p>
<p class="toc2"><a href="#/Book3/22chap18#chap18">8. Chile Willow</a></p>
<p class="toc2"><a href="#/Book3/23chap19#chap19">9. Summer Winds Up</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book3/24chap20#chap20">THREE: Burning Autumn</a></p>
<p class="toc2"><a href="#/Book3/25chap21#chap21">1. Green-Feathered Hat</a></p>
<p class="toc2"><a href="#/Book3/26chap22#chap22">2. The Magic Box</a></p>
<p class="toc2"><a href="#/Book3/27chap23#chap23">3. Dinner With Vernon</a></p>
<p class="toc2"><a href="#/Book3/28chap24#chap24">4. The Wrath of Five Thunders</a></p>
<p class="toc2"><a href="#/Book3/29chap25#chap25">5. Case #3432</a></p>
<p class="toc2"><a href="#/Book3/30chap26#chap26">6. Dead Man Driving</a></p>
<p class="toc2"><a href="#/Book3/31chap27#chap27">7. High Noon In Zephyr</a></p>
<p class="toc2"><a href="#/Book3/32chap28#chap28">8. From the Lost World</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book3/33chap29#chap29">FOUR: Winter’s Cold Truth</a></p>
<p class="toc2"><a href="#/Book3/34chap30#chap30">1. A Solitary Traveler</a></p>
<p class="toc2"><a href="#/Book3/35chap31#chap31">2. Faith</a></p>
<p class="toc2"><a href="#/Book3/36chap32#chap32">3. Snippets Of The Quilt</a></p>
<p class="toc2"><a href="#/Book3/37chap33#chap33">4. Mr. Moultry’s Castle</a></p>
<p class="toc2"><a href="#/Book3/38chap34#chap34">5. Sixteen Drops Of Blood</a></p>
<p class="toc2"><a href="#/Book3/39chap35#chap35">6. The Stranger Among Us</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book3/40chap36#chap36">FIVE: Zephyr as It is</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book3/41acknowledgments#acknowledgments">Acknowledgements</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?bb62e1f8